import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';

export default function NotificationSnackbar({notification, open, showNotification, ...props}) {
  // const [open, setOpen] = React.useState(false);
  function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    showNotification(false);
  };

  const {code, type, text} = notification;

  return (
    <div>
      {/* <Button onClick={handleClick}>Open Snackbar</Button> */}
      <Snackbar 
        open={open} 
        autoHideDuration={120000}
        // slots={{ transition: SlideTransition }} 
        onClose={handleClose}
        aria-labelledby="alert-snackbar-title"
        aria-describedby="alert-snackbar-description"
        >
        <Alert
          onClose={handleClose}
          severity={type}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {text}
        </Alert>
      </Snackbar>
    </div>
  );
}
